import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { cookieProvider } from '@/providers/CookieProvider';


const initialState: any = {
  token: cookieProvider.get('authToken') || null
};

export const tokenSlice = createSlice({
  name: 'token',
  initialState,
  reducers: {
    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
    }
  }
});

export const { setToken } = tokenSlice.actions;

export default tokenSlice.reducer;
